import React, { useState, useRef, useEffect } from 'react';
import { Helpers } from '../helpers/Helpers';
import Box from './Box';

interface PageHeaderModel {
    text: string
    ref: any
}

interface Props {
    items: (PageHeaderModel | undefined)[]
}

const PageHeader = ({ items }: Props) => {
    const headerRef: any = useRef();
    const [initialWidth, setInitialWidth] = useState(0);
    const [initialHeight, setInitialHeight] = useState(0);
    const [initialPosition, setInitialPosition] = useState(0);

    useEffect(() => {
        setInitialWidth(headerRef.current.offsetWidth)
        setInitialHeight(headerRef.current.offsetHeight)
        setInitialPosition(headerRef.current.getBoundingClientRect().top)
    }, [])

    return (
        <React.Fragment>
            <input style={{ display: 'none' }} id="initialWidth" value={initialWidth} />
            <input style={{ display: 'none' }} id="initialHeight" value={initialHeight} />

            <div style={{ height: Helpers.isEmpty(initialHeight) ? undefined : initialHeight }}>
                <div ref={headerRef} id="customHeaderContainer">
                    <Box border="1px solid #F1F1F4" boxShadow="0px 3px 4px 0px rgba(0, 0, 0, 0.03)" borderRadius="6px" overflow="hidden" flexDirection="row">
                        {
                            items.filter(x => x).map((item, index) => (
                                <Box
                                    justifyContent='center'
                                    id={"page-header-" + index}
                                    onClick={() => {
                                        var headerOffset = 120;
                                        var elementPosition = item?.ref.current.getBoundingClientRect().top;
                                        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                                        window.scrollTo({
                                            top: offsetPosition,
                                            behavior: "smooth"
                                        });
                                    }} flex={1} className={index == 0 ? "actionIcon bg-primary text-white p-2 text-center" : "actionIcon bg-white text-primary p-2 text-center"}>
                                    <span style={{ fontWeight: 'bold' }}>{item?.text}</span>
                                </Box>
                            ))
                        }

                        {/* <Box onClick={() => {
                            generalInformationRef.current?.scrollIntoView({
                                behavior: 'smooth'
                            })
                        }} flex={1} className="actionIcon bg-primary text-white p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Genel Bilgiler</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Ruhsat Bilgileri</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Teknik Bilgiler</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Araç Geçiş Kartları</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Süreli Belgeler</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Kiralama Bilgileri</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Satış Bilgileri</span>
                        </Box>
                        <Box flex={1} className="bg-white text-primary p-2 text-center">
                            <span style={{ fontWeight: 'bold' }}>Dijital Arşiv</span>
                        </Box> */}
                    </Box>
                </div>
            </div>
        </React.Fragment>
    );
}

export default PageHeader;